module.exports = __webpack_public_path__ + "img/chaveseguranca.85c49d29.png";